export default class BaseService {
	/**
	 * Application context. Holds reference to all the services and other global data/objects.
	 */
	context;

	constructor(context) {
		this.setContext(context);
	}

	setContext = (context) => {
		this.context = context;
	};
}
